// eslint-disable-next-line import/no-unresolved -- vite-plugin-pwa virtual module
import { registerSW } from 'virtual:pwa-register';

/**
 * Registers the app service worker via vite-plugin-pwa's virtual module
 * instead of its auto-injected script, so registration failures (proxy
 * auth challenges, network blips, corrupted sw.js) are caught here
 * rather than surfacing as unhandled promise rejections in Sentry.
 */
export default function registerServiceWorker() {
  registerSW({
    immediate: true,
    onRegisterError: error => {
      console.warn('Service worker registration failed', error); // eslint-disable-line no-console
    },
  });
}
